import { Translate } from '@chipinside/translate'
import {
  Box,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepIconProps,
  StepLabel,
  Stepper,
  styled,
} from '@mui/material'

import Colors from '#/styles/Colors'

const GREEN = Colors.theme.colors.primary.main
const INACTIVE_TEXT = Colors.theme.colors.neutral.dark

// Conector custom: linha verde quando concluída
const ColorlibConnector = styled(StepConnector)({
  '.MuiStepper-vertical &': {
    display: 'none',
  },
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: '14px',
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}, &.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]:
    {
      backgroundColor: GREEN,
    },
  [`& .${stepConnectorClasses.line}`]: {
    backgroundColor: INACTIVE_TEXT,
    border: 0,
    borderRadius: 1,
    height: 2,
  },
})

// Ícone custom: círculos com estados finished / active / default
const IconRoot = styled('div', {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'completed',
})<{ active?: boolean; completed?: boolean }>(({ active, completed }) => ({
  alignItems: 'center',
  borderRadius: '50%',
  boxSizing: 'border-box',
  display: 'flex',
  fontSize: 14,
  fontWeight: 700,
  height: 28,
  justifyContent: 'center',
  width: 28,
  // concluído: fundo verde, número branco
  ...(completed && {
    backgroundColor: '#fff',
    border: `2px solid ${GREEN}`,
    color: GREEN,
  }),
  // ativo: fundo branco, borda verde, número verde
  ...(active &&
    !completed && {
      backgroundColor: GREEN,
      border: `2px solid ${GREEN}`,
      color: '#fff',
    }),
  // inativo: fundo claro, borda cinza, número cinza
  ...(!active &&
    !completed && {
      backgroundColor: '#fff',
      border: `2px solid ${INACTIVE_TEXT}`,
      color: INACTIVE_TEXT,
    }),
}))

function CustomStepIcon(props: StepIconProps) {
  const { active, completed, icon } = props
  return (
    <IconRoot active={active} completed={completed}>
      {icon}
    </IconRoot>
  )
}

type StepsProps = {
  steps: any[]
  activeStepIndex: number
}

const FormbuilderStepper = ({ activeStepIndex, steps }: StepsProps) => {
  return (
    <Box sx={{ my: 1 }}>
      <Stepper
        alternativeLabel
        orientation={'horizontal'}
        activeStep={activeStepIndex}
        connector={<ColorlibConnector />}
        sx={{
          '& .MuiStepLabel-label': {
            '&.Mui-active,': {
              color: GREEN,
            },
            '&.Mui-completed': {
              color: GREEN,
            },
            '&.Mui-disabled': {
              color: INACTIVE_TEXT,
            },
            'fontSize': '0.9rem',
            'fontWeight': 700,
            'mt': `8px !important`,
          },
          'mb': 2,
          'position': 'relative',
        }}
      >
        {steps.map(({ label, optional }, index) => {
          const optionalText = optional ? ` (${Translate({ messageKey: 'optional' })})` : ''

          return (
            <Step key={index}>
              <StepLabel slots={{ stepIcon: CustomStepIcon }}>
                {label} {optionalText}
              </StepLabel>
            </Step>
          )
        })}
      </Stepper>
    </Box>
  )
}

export { FormbuilderStepper }
